import { createApp } from 'vue'
import router from './router/router'
import App from './App.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faPlus, faHome, faList, faTimes, faHeart } from '@fortawesome/free-solid-svg-icons'
import { faDiscord, faPatreon } from '@fortawesome/free-brands-svg-icons'
library.add(faBars, faPlus, faHome, faList, faTimes, faHeart, faDiscord, faPatreon)

createApp(App)
    .component('fa', FontAwesomeIcon)
    .use(router)
    .mount('#app')